import { render, staticRenderFns } from "./FacestreamSlot.vue?vue&type=template&id=a99dafc6&scoped=true"
import script from "./FacestreamSlot.vue?vue&type=script&lang=js"
export * from "./FacestreamSlot.vue?vue&type=script&lang=js"
import style0 from "./FacestreamSlot.vue?vue&type=style&index=0&id=a99dafc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99dafc6",
  null
  
)

export default component.exports